export default __webpack_public_path__ + "static/media/mentalHealthAnna.c1786d7f.jpg";